/**
 * FinlyLogoMark — Renderiza el logo OFICIAL de Finly+ (imagen completa con ícono + texto).
 *
 * Diseño personalizado del usuario (José Luis).
 * Se usa SOLO en zonas grandes (hero de Landing, /early, login y register a ~120px).
 * Para el nav/header pequeño se sigue usando el SVG `FinlyLogo` (verde olivo).
 *
 * Props:
 *   size      altura en px (default 120). El ancho se ajusta proporcionalmente.
 *   className clases extra
 *   alt       texto alternativo (default "Finly+")
 */
import logoSrc from "@/assets/finly-logo-full.png";

export function FinlyLogoMark({ size = 120, className = "", alt = "Finly+" }) {
  const px = typeof size === "number" ? `${size}px` : size;
  return (
    <img
      src={logoSrc}
      alt={alt}
      style={{ height: px, width: "auto", display: "block" }}
      className={`select-none ${className}`}
      draggable={false}
      data-testid="finly-logo-mark"
    />
  );
}

export default FinlyLogoMark;
